import { User } from "@/models/User";
import { camelCase, startCase } from "lodash";
import moment from "moment";
import SA from "sweetalert2";
import config from "@/util/constants";

export const humanize = (value: string): string =>
  startCase(value.split("@")[0]).replace("Oneill", "O’Neill");

export const initials = (user: User): string =>
  humanize(user.email)
    .split(" ")
    .map((w) => w[0])
    .join("");

export const timeAgo = (value: string): string =>
  value ? moment(value, "YYYY-MM-DD HH:mm:ss").fromNow() : value;

export const Confirmation = SA.mixin({
  title: "Please confirm",
  buttonsStyling: false,
  customClass: {
    confirmButton: "btn btn-info",
    cancelButton: "btn btn-outline-danger mr-3",
  },
  showCloseButton: true,
  showCancelButton: true,
  reverseButtons: true,
  focusConfirm: true,
  focusCancel: false,
});

export const titleCase = (s: string) => startCase(camelCase(s));

export const makeCategory = (key: string) => ({
  uri: `/meta_cat/${new Map<string, string>(Object.entries(config.metaCat)).get(
    key
  )}`,
  id: `${key}`,
  label: titleCase(key.replace(/_cat|v_/g, "")),
  meta: null,
  data: null,
});
// export const makeCategory = (key: string) => ({
// uri: `/meta_cat/${Object.entries(config.metaCat).find(([pkey, value]) => {
//   if (pkey === key) {
//     return value;
//   }
//   return null;
// })}`,
//   uri: `/data_mgmt/all/System/${key}`,
//   id: `${key}`,
//   label: titleCase(key.replace(/_cat|v_/g, "")),
//   meta: null,
//   data: null,
// });
